export default __webpack_public_path__ + "static/media/permissionDenied.483fee51.svg";